module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-top-ties-remnants.e35b45ea.png";